export function textAnimation() {
  const home = document.querySelector('.home');
  const screen = document.querySelector('.screen');
  const benefits = document.querySelector('.benefits');

  home.querySelectorAll('.text-animation').forEach((srceenItem, index) => {
    setTimeout(() => {
      srceenItem.classList.add('show');
    }, index * 300);
  })

  if (screen.getBoundingClientRect().top < window.innerHeight / 2) {
    screen.querySelectorAll('.text-animation').forEach((srceenItem, index) => {
      setTimeout(() => {
        srceenItem.classList.add('show');
      }, index * 300);
    })
  }

  if (benefits.getBoundingClientRect().top < window.innerHeight / 2) {
    benefits.querySelectorAll('.benefits__item').forEach((srceenItem, index) => {
      setTimeout(() => {
        srceenItem.classList.add('show');
      }, index * 300);
    })
  }

  document.removeEventListener('scroll', textAnimation, false);
}